module.exports = __webpack_public_path__ + "static/media/beetrootncarrotsalad.6bd9e614.jpg";